import { createGlobalStyle } from 'styled-components'

import 'normalize.css'
import './var.css'
import './icon.css'
import '../fonts/stylesheet.css'
import hogasiaModalLogo from '../images/logoHogasia.jpg'
import m87ModalLogo from '../images/m87-logo/m87-logo.svg'
import passportModalLogo from '../logo-sm.png'
import { THEME_CLASSNAMES } from '../../config'

const PassportStyles = createGlobalStyle`

:root {
  --red: #ef5236;
  --yellow: #f7a01d;
  --white: #ffffff;
}

div,
p,
img,
h1,
h2,
h3,
h4,
h5,
h6 {
  padding: 0;
  margin: 0;
}
ul,
ol {
  list-style: none;
}

p {
  margin: 0;
}
*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  color: var(--white);
}
.c-p {
  cursor: pointer;
}

.b-shadow {
  box-shadow: 0 12px 13px 0 #00000075;
}
    body {
     margin: 0;
     padding: 0;
     font-family: "Monsterrat", "Oxygen", sans-serif;
     line-height: 20px;
     font-weight: 300;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
     font-size: 16px;
     background: #3f317c;
     letter-spacing:0.03em;
      
    }
    .modalBg {

  background: rgb(46, 25, 65);
  background: linear-gradient(
    90deg,
    rgba(46, 25, 65, 1) 0%,
    rgba(53, 49, 124, 1) 52%
  );
  .modalTopBg{
    background: #1f193f;
   }

  .modalLogo{
    content: url(${passportModalLogo});

   }


}

`
const HogasiaStyles = createGlobalStyle`
:root {
  --red: #ff6b35;
  --yellow: #f7931e;
  --white: #ffffff;
}

div,
p,
img,
h1,
h2,
h3,
h4,
h5,
h6 {
  padding: 0;
  margin: 0;
}
ul,
ol {
  list-style: none;
}

p {
  margin: 0;
}
*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  color: var(--white);
}
.c-p {
  cursor: pointer;
}

.b-shadow {
  box-shadow: 0 12px 13px 0 #00000075;
}

    body {
    margin: 0;
    padding: 0;
    font-family: "Monsterrat", "Oxygen", sans-serif;
    line-height: 20px;
    font-weight: 300;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    background-color: #262626;
    letter-spacing:0.03em;
    }
    .modalBg {
   background: rgb(38, 34, 35);
   background: linear-gradient(
     110deg,
    rgba(38, 34, 35, 1) 0%,
    rgba(191, 140, 44, 1) 100%
   );
   .modalTopBg{
    background:  #262626;
   
   }

   .modalLogo{
    content: url(${hogasiaModalLogo});

   }
}

`
const M87Styles = createGlobalStyle`
:root {
  --red: #ff1d55;
  --yellow: #ffd700;
  --white: #ffffff;
}

div,
p,
img,
h1,
h2,
h3,
h4,
h5,
h6 {
  padding: 0;
  margin: 0;
}
ul,
ol {
  list-style: none;
}

p {
  margin: 0;
}
*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  color: var(--white);
}
.c-p {
  cursor: pointer;
}

.b-shadow {
  box-shadow: 0 12px 13px 0 #00000075;
}

    body {
    margin: 0;
    padding: 0;
    font-family: "Monsterrat", "Oxygen", sans-serif;
    line-height: 20px;
    font-weight: 300;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    background-color: #161618;
    letter-spacing:0.03em;
    }
    .modalBg {
   background: rgb(22, 22, 24);
   background: linear-gradient(
     110deg,
    rgba(22, 22, 24, 1) 0%,
    rgba(255, 29, 85, 1) 100%
   );
   .modalTopBg{
    background: #161618;
   
   }

   .modalLogo{
    content: url(${m87ModalLogo});

   }
}

`

let style =
  THEME_CLASSNAMES[window.location.hostname] || THEME_CLASSNAMES.default

let GlobalStyles

switch (style) {
  case 'hogasia':
    GlobalStyles = HogasiaStyles
    break
  case 'passport':
    GlobalStyles = PassportStyles
    break
  case 'm87':
    GlobalStyles = M87Styles
    break
  default:
}
export default GlobalStyles
